import { Enum } from '../../../common/constants'
import { InvoiceSummary, wasInvoiceSent } from '../../../domain/invoicing/invoice'

export const SendFlows = {
  Reminder: 'reminder',
  SynkedUPSend: 'synkedup-send',
  QuickBooksEmail: 'qbo-email',
} as const

export type SendFlow = Enum<typeof SendFlows>

export const resolveSendFlow = (summary: InvoiceSummary): SendFlow => {
  if (wasInvoiceSent(summary)) {
    return SendFlows.Reminder
  }
  if (summary.invoicingSystem === 'synkedUp') {
    return SendFlows.SynkedUPSend
  }
  return SendFlows.QuickBooksEmail
}
